import { validatePhoneUrl } from '../../config';

import { createOrGetVisitor } from './Visitor';
import { shouldVerifyOTP } from './Otp';
import request from './Request';
import EventBus from './EventBus';
import {
  putCookie,
  getCookie,
  deleteLocalStorage,
  getLocalStorage,
  putLocalStorage
} from './LocalStorage';
import { isResellerLoginRequired } from './Reseller';
import { isSharedOrderOpened } from './Amalgam';

export const INTENT = {
  ADD_INQUIRY: 'ADD_INQUIRY',
  RESELL: 'RESELL',
  SUBSCRIBE: 'SUBSCRIBE',
  CHANGE_PHONE: 'CHANGE_PHONE',
  VIEW_ORDERS: 'VIEW_ORDERS',
  MODIFY_MARGIN: 'MODIFY_MARGIN',
  SHARE_OR_SELECT: 'SHARE_OR_SELECT'
};

let _identity = {};

const getIdentityFromVisitor = () =>
  createOrGetVisitor().then((visitor) => {
    const id = {};

    if (visitor.name) {
      id.name = visitor.name;
    }

    if (visitor.email) {
      id.email = visitor.email;
    }

    if (visitor.phone) {
      id.phone = visitor.phone;
    }

    if (visitor.phoneVerified !== undefined) {
      id.phoneVerified = visitor.phoneVerified;
    }

    return Promise.resolve(id);
  });

export const getIdentity = () =>
  getIdentityFromVisitor().then((identity) => {
    _identity = identity;
    return Promise.resolve(identity);
  });

export const isPhoneProper = () =>
  new Promise((resolve) => {
    isResellerLoginRequired().then((loginRequired) => {
      if (loginRequired) {
        // send back false so that login is requested
        resolve(false);
        return;
      }

      const answer = _identity.phone && _identity.phone.length > 6;

      if (shouldVerifyOTP()) {
        resolve(answer && _identity.phoneVerified);
      }

      resolve(answer);
    });
  });

export const validatePhone = (e164Number) =>
  request({
    method: 'POST',
    url: validatePhoneUrl,
    params: {
      e164Number
    }
  });

const saveIdentityToVisitor = (identity) =>
  createOrGetVisitor()
    .then((visitor) => visitor.setIdentity(identity))
    .then(() => Promise.resolve(identity));

export const setIdentity = (identity) =>
  saveIdentityToVisitor(identity).then(() => {
    if (!_identity) {
      _identity = {};
    }

    if (identity.name) {
      _identity.name = identity.name;
    }

    if (identity.email) {
      _identity.email = identity.email;
    }

    if (identity.phone) {
      _identity.phone = identity.phone;
    }

    if (identity.phoneVerified !== undefined) {
      _identity.phoneVerified = identity.phoneVerified;
    }

    EventBus.notify(EventBus.TYPE.IDENTITY_CHANGED);

    return Promise.resolve(_identity);
  });

export const identityRequested = () => {
  putCookie('request_identity', true);
};

export const identityComplete = () => {
  putCookie('request_identity', false);
};

export const didInterruptIdentityRequest = () => getCookie('request_identity') === 'true';

export const getBillingDetails = () => {
  if (isSharedOrderOpened()) {
    return Promise.resolve();
  }
  return Promise.resolve(getLocalStorage('CUSTOMER_DETAILS'));
};

export const setBillingDetails = (updateData) => {
  if (isSharedOrderOpened()) {
    return;
  }
  if (!updateData) {
    deleteLocalStorage('CUSTOMER_DETAILS');
    return;
  }

  return getBillingDetails().then((customerData) => {
    const mergedData = { ...(customerData || {}), ...updateData };
    putLocalStorage('CUSTOMER_DETAILS', mergedData);
  });
};

export const getShippingAddressDetails = () => {
  if (isSharedOrderOpened()) {
    return;
  }
  return getLocalStorage('SHIPPING_ADDRESS');
};

export const setShippingAddressDetails = (shippingAddress) => {
  if (isSharedOrderOpened()) {
    return;
  }
  if (!shippingAddress) {
    deleteLocalStorage('SHIPPING_ADDRESS');
    return;
  }
  const oldShippingAddress = getShippingAddressDetails() || {};
  putLocalStorage('SHIPPING_ADDRESS', { ...oldShippingAddress, ...shippingAddress });
};
